import { type FC } from "react";

import { type PlaybookCategory } from "../../../../graphql.js";
import { ProtectedResourceLogo } from "../../ProtectedResourceLogo.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import TextCell from "./core/TextCell.js";

const CategoriesAdminCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }
  const category: PlaybookCategory = props.data.category;
  const protectedCategory = category.protectedCategory;

  const onCategoryClicked =
    typeof (props as any).handleCategoryClicked === "function" && (props as any).handleCategoryClicked;

  return (
    <TableCell
      triggerButtonProps={{
        icon: protectedCategory ? <ProtectedResourceLogo /> : onCategoryClicked && "edit",
        onPress: onCategoryClicked && !protectedCategory ? () => onCategoryClicked(category) : undefined,
        label: onCategoryClicked && !protectedCategory ? "Edit category" : undefined,
      }}
    >
      <TextCell {...props} tooltip={props.value} />
    </TableCell>
  );
};

export { CategoriesAdminCell };
export default CategoriesAdminCell;
